module.exports = __webpack_public_path__ + "img/discont_welcome_header.2dc61eaa.png";